import { getItemIdRelativeSubfolder } from './itemIdSubfolderUtils';

/**
 * These properties describe possible locations of an highres or proxy file which can be either
 * a legacy path where the target file is a direct child of the media folder like
 * ".../ccba3d80-ba29-444c-9a79-e0bc68538970.mxf"
 * or a subfolder path like ".../v1/cc/ba/ccba3d80-ba29-444c-9a79-e0bc68538970.mxf"
 */
export interface MediaDestination {
  legacyDestinationPath: string;
  subfoldersDestinationPath: string;
}


export function getMediaDestination(
  downloadPath: string,
  basename: string,
  pathSep: string,
): MediaDestination {
  const legacyDestinationPath = `${downloadPath}${pathSep}${basename}`;
  const subfoldersDestinationPath = `${downloadPath}${pathSep}${getItemIdRelativeSubfolder(basename, pathSep)}${pathSep}${basename}`;
  return {
    legacyDestinationPath,
    subfoldersDestinationPath,
  };
}
